// Step 5 — Write your first post.
//
// BKA renders a starter site (in the browser) and commits it to the
// public repo. We collect a display name + one-line bio so the site
// feels like theirs from the first commit; the starter post itself is
// fixed ("Hello, world"). This runs BEFORE the Cloudflare connect so
// that the moment they wire up Pages, real content is already there to
// serve.

import { useState } from "react";
import { useAuthStore } from "../../store/authStore";
import { useOnboardingStore } from "../../store/onboardingStore";
import { defaultSiteUrl } from "../../lib/handle";

export function StepPublish() {
  const user = useAuthStore((s) => s.user)!;
  const handle = useOnboardingStore((s) => s.record?.handle) ?? "";
  const busy = useOnboardingStore((s) => s.busy);
  const error = useOnboardingStore((s) => s.error);
  const publishStarter = useOnboardingStore((s) => s.publishStarter);

  const [displayName, setDisplayName] = useState(user.name);
  const [bio, setBio] = useState("");

  const onPublish = () => {
    if (busy) return;
    void publishStarter(user.sub, displayName, bio);
  };

  return (
    <div className="step">
      <div className="step-kicker">Step 5 of 7</div>
      <h1 className="step-title">Write your first post</h1>
      <p className="step-why">
        BKA will render a starter “Hello, world” post into a complete static site and commit it
        to your public repo. No build step, nothing to break — just finished HTML your site can
        serve. First, a couple of details so it reads as <em>yours</em>.
      </p>

      <div className="step-field">
        <label className="step-label" htmlFor="dn">Display name</label>
        <input id="dn" className="step-input" type="text" value={displayName}
          onChange={(e) => setDisplayName(e.target.value)} placeholder="Christopher Bender" />
      </div>

      <div className="step-field">
        <label className="step-label" htmlFor="bio">One-line bio</label>
        <input id="bio" className="step-input" type="text" value={bio}
          onChange={(e) => setBio(e.target.value)} placeholder="Writing on my own corner of the internet." />
      </div>

      <div className="pub-preview">
        <div className="pub-preview-head">your site will publish to</div>
        <code>{defaultSiteUrl(handle).replace("https://", "")}</code>
      </div>

      <div className="step-actions">
        <button className="step-btn" disabled={busy} onClick={onPublish}>
          {busy ? "Publishing…" : "Publish my first post"}
        </button>
      </div>

      {error && (
        <div className="step-error">
          <div className="step-error-title">couldn't publish</div>
          {error}
        </div>
      )}

      <style>{`
        .pub-preview {
          background: var(--paper-raised); border: 1px solid var(--line);
          border-radius: var(--radius-1); padding: var(--space-3) var(--space-4);
          margin-bottom: var(--space-2);
        }
        .pub-preview-head {
          font-family: var(--font-mono); font-size: 11px;
          text-transform: uppercase; letter-spacing: 0.06em; color: var(--ink-faint);
          margin-bottom: 4px;
        }
        .pub-preview code { font-family: var(--font-mono); font-size: 13px; color: var(--ink); }
      `}</style>
    </div>
  );
}
